<template>
  <tr class="data-row" :class="{ 'alternate-row': isAlternate }">
    <td class="data-row-text">
      {{ name }}
    </td>
    <td class="text-left">
      <BouncingDots v-if="contributionValuesLoading" />
      <span v-else class="data-row-text" :style="{ color: textColor }">{{
        yearToDate
      }}</span>
    </td>
    <td class="text-left">
      <BouncingDots v-if="contributionValuesLoading" />
      <span v-else class="data-row-text" :style="{ color: textColor }">{{
        rollingTwelveMonths
      }}</span>
    </td>
    <td>
      <BouncingDots v-if="inputIsLoading" />
      <span v-else class="data-row-text" :style="{ color: textColor }">{{
        displayInput
      }}</span>
    </td>
  </tr>
</template>
        
<script>
import BouncingDots from "@/views/components/BouncingDots.vue";

export default {
  name: "DataTable",
  components: {
    BouncingDots,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    yearToDate: {
      type: String,
      required: true,
    },
    isAlternate: {
      type: Boolean,
      required: false,
      default: false,
    },
    rollingTwelveMonths: {
      type: String,
      required: true,
    },
    input: {
      type: String,
      required: true,
    },
    inputIsLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    contributionValuesLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    textColor: {
      type: String,
      required: false,
      default: "inherit",
    },
  },
  data: function () {
    return {};
  },
  computed: {
    displayInput() {
      return this.inputIsLoading ? "Loading..." : this.input;
    },
  },
};
</script>
        
<style scoped>
/* Header Styles */
.header-title-row {
  background-color: var(--color-primary) !important;
  color: var(--color-text) !important;
  font-size: 1.1em;
  height: 48px;
}

.header-main-row {
  background-color: var(--color-primary) !important;
  color: var(--color-text) !important;
}

.header-cell {
  padding: 0 16px !important;
  height: 48px;
  font-weight: 500 !important;
  white-space: nowrap;
  cursor: default;
  color: var(--color-text) !important;
}

.header-cell.sortable {
  cursor: pointer;
}

.header-cell.sortable:hover {
  background-color: var(--color-primary-light) !important;
}

.header-filter-row {
  background-color: var(--color-primary-light) !important;
}

.header-filter {
  margin: 8px 4px !important;
}

/* Existing Body Styles */
.summary-row {
  background-color: var(--color-surface) !important;
  font-weight: bold;
  border-bottom: 2px solid var(--color-border) !important;
}

.data-row {
  height: 48px;
  transition: background-color 0.2s;
  background-color: var(--color-bg) !important;
}

.data-row:hover {
  background-color: var(--color-overlay) !important;
}

.highlight-row {
  background-color: var(--color-primary-light) !important;
}

.alternate-row {
  background-color: var(--color-surface) !important;
}

.footer-row {
  background-color: var(--color-surface) !important;
  border-top: 2px solid var(--color-border) !important;
}

.input-field {
  max-width: 120px;
}

td {
  padding: 0 16px !important;
  vertical-align: middle !important;
  border-bottom: 1px solid var(--color-border) !important;
}

.text-right {
  text-align: right !important;
}

.data-row-text {
  font-size: 0.95em;
  color: var(--color-text) !important;
}
</style>
  
  